// extracted by mini-css-extract-plugin
export default {"contact":"ContactCard_contact__KwytL"};